import { InputHTMLAttributes, ReactNode } from 'react';
import { FlattenSimpleInterpolation } from 'styled-components';
import { MarginProps } from 'styled-system';

import { PasswordCondition, Placement } from './components/password-helper/PasswordHelper.types';
import { ThemeType } from 'src/packages/theme';

export type InputVariant = 'primary' | 'secondary';

export enum InputSize {
  DEFAULT = '48px',
  SMALL = '40px',
}

export interface InternalInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string | ReactNode;
  helperTextOnFocus?: string;
  invalid?: boolean;
  showPasswordHelp?: boolean;
  passwordHelpSide?: Placement;
  passwordConditions?: PasswordCondition[];
  errorMessage?: string;
  patternMessage?: string;
  leftElement?: ReactNode;
  rightElement?: ReactNode;
  autoFocus?: boolean;
  width?: string;
  borderRadius?: string;
  variant?: InputVariant;
  theme?: ThemeType;
}

export type InputProps = InternalInputProps &
  MarginProps & {
    colorStyles?: FlattenSimpleInterpolation;
  };
